import { type PostUserLoginAuthTokenPayload } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

import { fetchUserLoginAuthToken } from '../api/fetchUserLoginAuthToken';

/**
 * @param PostUserLoginAuthTokenPayload
 */
export const useUserAuthValidationQuery = (params: PostUserLoginAuthTokenPayload) => {
	return useQuery({
		enabled: !!params.generatedCode && !!params.userId && !!params.deviceUid && !!params.consumerName,
		queryFn: () => fetchUserLoginAuthToken(params),
		queryKey: [params]
	});
};
